import React, { useState, useEffect } from 'react';
import axios from 'axios';
import regresaBienFecha from '../tools/regresaBienFecha';
import Modal from './Modal.jsx';
import ModalPlanillas from './Modal.jsx';
import ModalCalifica from './Modal.jsx';
import CreaInstancia from './CrearInstancia.jsx';
import InstanciaEditable from './InstanciaEditable.jsx';
import socket from '../tools/socke.js';
import ObtieneDatosCookies from '../obtieneDatosCookiesUsuario.js';
import Swal from 'sweetalert2';
import NotasPorInstancia from './NotasPorInstancia.jsx';
import ListadoMaterias from './ListadoMaterias.jsx';
import TableroCalificacionesInstancia from './TableroCalificacionesInstancia.jsx';
import comprueboPermisos from '../tools/comprueboPermisos.js';
import ImportarNotasMoodleSIGEDI from './ImportarNotasMoodleSIGEDI.jsx';
const UserManagement = () => {
  const [instancias, setInstancias] = useState([]);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [modalEdicion, setModalEdicion] = useState(false);
  const [modalPlanillas, setModalPlanillas] = useState(false);
  const [modalCalifica, setModalCalifica] = useState(false);
  const [modalEstadoCalificaciones, setModalEstadoCalificaciones] = useState(false);
  const [instanciaSeleccionada, setInstanciaSeleccionada] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [escuelaSeleccionada, setEscuelaSeleccionada] = useState(null);
  const [acordeonAbierto, setAcordeonAbierto] = useState({});
  const [modalImportarNotas, setModalImportarNotas] = useState(false);
  const Usuario = ObtieneDatosCookies();

  const devuelveInstancias = async (estado) => {
    try {
      const url = estado
        ? `https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/devuelveInstancias?estado=${estado}`
        : `https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/devuelveInstancias/`;

      const resultado = await axios.post(url);

      if (resultado?.data?.instanciaDevuelta) {
        setInstancias(resultado.data.instanciaDevuelta);
      }
    } catch (error) {
      console.error('Error al obtener instancias:', error);
    }
  };

  useEffect(() => {
    const Usuario = ObtieneDatosCookies();
    const textoFuncion = Usuario.funcion || "";

    const palabrasClave = [
      "Escuela de Policia",
      "Escuela de Especialidades",
      "Escuela Superior",
      "Escuela de Investigaciones",
      "Educacion a Distancia",
"Extension Comunitaria",
      'Extracurricular',



    ];

    const escuelasEncontradas = palabrasClave.filter(clave =>
      textoFuncion.includes(clave)
    );

    if (Usuario.destino == 1 || Usuario.destino == 7) {
      setEscuelaSeleccionada("Todo");
    } else if (escuelasEncontradas.length > 0) {
      setEscuelaSeleccionada(escuelasEncontradas.join(','));
    } else {
      setEscuelaSeleccionada("Escuela de Policia");
    }
  }, []);

  useEffect(() => {
    devuelveInstancias();
  }, []);

  const handleEditClick = async (id, estadoInstancia) => {
    const accion = estadoInstancia === 'Activo' ? 'anular' : 'restaurar';

    const confirmResult = await Swal.fire({
      title: `¿Estás seguro que quieres ${accion} esta instancia?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, confirmar',
      cancelButtonText: 'Cancelar',
    });

    if (confirmResult.isConfirmed) {
      try {
        const estadoRespuesta = estadoInstancia === 'Activo' ? 'Anulado' : 'Activo';

        const resultado = await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/actualizaInstancia/${id}`,
          { estado: estadoRespuesta }
        );

        if (resultado) {
          socket.emit('NovedadInstancia', '');
          devuelveInstancias('Activo');
          Swal.fire('¡Listo!', `Instancia ${accion}da correctamente.`, 'success');
        }
      } catch (error) {
        console.error('Error actualizando instancia:', error);
        Swal.fire('Error', 'No se pudo actualizar la instancia.', 'error');
      }
    }
  };

  const cierraModal = () => {
    devuelveInstancias('Activo');
    setModalAbierto(false);
    setModalEdicion(false);
    setInstanciaSeleccionada(null);
    socket.emit('NovedadInstancia', '');
  };

  const filteredInstancias = React.useMemo(() => {
    if (!escuelaSeleccionada || escuelaSeleccionada === 'Todo') {
      return instancias;
    }

    const escuelasFiltro = escuelaSeleccionada.split(',').map(e => e.trim());

    return instancias.filter(instancia =>
      escuelasFiltro.includes(instancia.escuela)
    );
  }, [instancias, escuelaSeleccionada]);

  const sortedInstancias = React.useMemo(() => {
    let sortable = [...filteredInstancias];

    if (sortConfig.key) {
      sortable.sort((a, b) => {
        const valA = a[sortConfig.key] ?? '';
        const valB = b[sortConfig.key] ?? '';

        if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
        if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;

        return 0;
      });
    }

    return sortable;
  }, [filteredInstancias, sortConfig]);

  const groupedByEscuelaYCursos = React.useMemo(() => {
    const agrupado = sortedInstancias.reduce((acc, instancia) => {
      const escuela = instancia.escuela || 'Sin Escuela';
      const curso = instancia.nombreCurso || 'Sin Curso';

      if (!acc[escuela]) acc[escuela] = {};
      if (!acc[escuela][curso]) acc[escuela][curso] = [];

      acc[escuela][curso].push(instancia);

      return acc;
    }, {});

    return agrupado;
  }, [sortedInstancias]);

  const obtenerInstanciasDelCurso = () => {
    if (!instanciaSeleccionada) return [];

    if (instanciaSeleccionada.idCurso) {
      return instancias.filter(
        i => String(i.idCurso) === String(instanciaSeleccionada.idCurso)
      );
    }

    return instancias.filter(
      i => String(i.nombreCurso || '').trim() === String(instanciaSeleccionada.nombreCurso || '').trim()
    );
  };

  return (
    <>
      <div style={{ marginBottom: '15px' }}>
        <button
          onClick={() => setModalAbierto(true)}
          style={styles.btnCrear}
        >
          ➕ Crear Instancia
        </button>
      </div>

      <Modal isOpen={modalAbierto} onClose={cierraModal}>
        <CreaInstancia Instancias={instancias} myID={cierraModal} />
      </Modal>

      <Modal isOpen={modalEdicion} onClose={cierraModal}>
        {instanciaSeleccionada && (
          <InstanciaEditable
            instancia={instanciaSeleccionada}
            cierraModal={cierraModal}
          />
        )}
      </Modal>
      <Modal
        isOpen={modalImportarNotas}
        onClose={() => setModalImportarNotas(false)}
      >
        <div style={styles.modalPantallaCompleta}>
          <div style={styles.modalHeaderFull}>
            <div>
              <h2 style={{ margin: 0 }}>📥 Importar Notas Moodle / SIGEDI</h2>

              <div style={{ opacity: 0.8 }}>
                {instanciaSeleccionada?.nombreInstancia}
              </div>

              <div style={{ opacity: 0.7, fontSize: 13 }}>
                Curso: {instanciaSeleccionada?.nombreCurso}
              </div>
            </div>

            <button
              onClick={() => setModalImportarNotas(false)}
              style={styles.btnCerrarModalFull}
            >
              Cerrar
            </button>
          </div>

          <div style={{ flex: 1, overflow: "auto", padding: 20 }}>
            {instanciaSeleccionada && (
              <ImportarNotasMoodleSIGEDI instancia={instanciaSeleccionada} />
            )}
          </div>
        </div>
      </Modal>
    <ModalPlanillas
  isOpen={modalPlanillas}
  onClose={() => setModalPlanillas(false)}
>
  <div style={styles.modalPantallaCompleta}>
    <div style={styles.modalHeaderFull}>
      <div>
        <h2 style={{ margin: 0 }}>
          Planillas de calificaciones
        </h2>

        <div style={{ opacity: 0.8 }}>
          {instanciaSeleccionada?.nombreInstancia}
        </div>

        <div style={{ opacity: 0.7, fontSize: 13 }}>
          Curso: {instanciaSeleccionada?.nombreCurso}
        </div>
      </div>

      <button
        onClick={() => setModalPlanillas(false)}
        style={styles.btnCerrarModalFull}
      >
        Cerrar
      </button>
    </div>

    <div
      style={{
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        overflowX: "hidden",
        padding: "20px",
      }}
    >
      {instanciaSeleccionada && (
        <NotasPorInstancia
          instanciaId={instanciaSeleccionada}
        />
      )}
    </div>
  </div>
</ModalPlanillas>

      <ModalCalifica isOpen={modalCalifica} onClose={() => setModalCalifica(false)}>
        {instanciaSeleccionada && (
          <ListadoMaterias instancia={instanciaSeleccionada} />
        )}
      </ModalCalifica>

      <Modal
        isOpen={modalEstadoCalificaciones}
        onClose={() => setModalEstadoCalificaciones(false)}
      >
        <div style={styles.modalPantallaCompleta}>
          <div style={styles.modalHeaderFull}>
            <div>
              <h2 style={{ margin: 0 }}>
                📊 Estado de Calificaciones
              </h2>

              <div style={{ opacity: 0.8 }}>
                {instanciaSeleccionada?.nombreInstancia}
              </div>

              <div style={{ opacity: 0.7, fontSize: 13 }}>
                Curso: {instanciaSeleccionada?.nombreCurso}
              </div>
            </div>

            <button
              onClick={() => setModalEstadoCalificaciones(false)}
              style={styles.btnCerrarModalFull}
            >
              Cerrar
            </button>
          </div>

          <div style={{ flex: 1, overflow: "auto" }}>
            <TableroCalificacionesInstancia
              instanciaId={instanciaSeleccionada?.id}
              instanciaSeleccionada={instanciaSeleccionada}
              instanciasCurso={obtenerInstanciasDelCurso()}
            />
          </div>
        </div>
      </Modal>

      <div style={{ marginBottom: '15px' }}>
        <button
          onClick={() => devuelveInstancias(null)}
          style={styles.btnTodas}
        >
          📋 Ver Todas
        </button>

        <button
          onClick={() => devuelveInstancias('Activo')}
          style={styles.btnActivas}
        >
          ✅ Ver Activas
        </button>
      </div>

      <div style={{ overflowX: 'auto' }}>
        {Object.keys(groupedByEscuelaYCursos).map((escuela) => (
          <div key={escuela} style={{ marginBottom: '20px' }}>
            <h3
              style={styles.tituloEscuela}
              onClick={() => {
                setAcordeonAbierto((prev) => ({
                  ...prev,
                  [escuela]: !prev[escuela],
                }));
              }}
            >
              {escuela} {acordeonAbierto[escuela] ? '⬇️' : '➡️'}
            </h3>

            {acordeonAbierto[escuela] &&
              Object.keys(groupedByEscuelaYCursos[escuela]).map((curso) => (
                <div key={curso} style={{ marginLeft: '20px', marginTop: '10px' }}>
                  <h4
                    style={styles.tituloCurso}
                    onClick={() => {
                      setAcordeonAbierto((prev) => ({
                        ...prev,
                        [escuela]: {
                          ...prev[escuela],
                          [curso]: !prev[escuela]?.[curso],
                        },
                      }));
                    }}
                  >
                    {curso} {acordeonAbierto[escuela]?.[curso] ? '⬇️' : '➡️'}
                  </h4>

                  {acordeonAbierto[escuela]?.[curso] && (
                    <table style={styles.table}>
                      <thead style={{ background: '#f5f5f5' }}>
                        <tr>
                          <th style={styles.th}>Instancia</th>
                          <th style={styles.th}>Curso</th>
                          <th style={styles.th}>Fecha Inicial</th>
                          <th style={styles.th}>Fecha Final</th>
                          <th style={styles.th}>Estado</th>
                          <th style={styles.th}>Acciones</th>
                        </tr>
                      </thead>

                      <tbody>
                        {groupedByEscuelaYCursos[escuela][curso].map((instancia) => (
                          <tr key={instancia.id}>
                            <td style={styles.td}>{instancia.nombreInstancia}</td>
                            <td style={styles.td}>{instancia.nombreCurso}</td>
                            <td style={styles.td}>{regresaBienFecha(instancia.fechaInicio)}</td>
                            <td style={styles.td}>{regresaBienFecha(instancia.fechaFinal)}</td>
                            <td style={styles.td}>{instancia.estado}</td>

                            <td style={styles.td}>
                              <button
                                onClick={() => handleEditClick(instancia.id, instancia.estado)}
                                style={{
                                  ...styles.btnAccion,
                                  background: instancia.estado === 'Activo' ? '#f44336' : '#4caf50',
                                }}
                              >
                                {instancia.estado === 'Activo' ? 'Anular' : 'Restaurar'}
                              </button>

                              <button
                                onClick={() => {
                                  setInstanciaSeleccionada(instancia);
                                  setModalEdicion(true);
                                }}
                                style={{ ...styles.btnAccion, background: '#ff9800' }}
                              >
                                ✏️ Editar
                              </button>

                              <button
                                onClick={() => {
                                  setInstanciaSeleccionada(instancia);
                                  setModalPlanillas(true);
                                }}
                                style={{ ...styles.btnAccion, background: '#206e16ff' }}
                              >
                                Planillas
                              </button>

                              <button
                                onClick={() => {
                                  setInstanciaSeleccionada(instancia);
                                  setModalCalifica(true);
                                }}
                                style={{ ...styles.btnAccion, background: '#941717ff' }}
                              >
                                Calificar
                              </button>
                              {comprueboPermisos(Usuario.funcion, "Importar Moodle Sigedi") ?
                                <button
                                  onClick={() => {
                                    setInstanciaSeleccionada(instancia);
                                    setModalImportarNotas(true);
                                  }}
                                  style={{ ...styles.btnAccion, background: '#7c3aed' }}
                                >
                                  📥 Importar Moodle/SIGEDI
                                </button> : ""}
                              {comprueboPermisos(Usuario.funcion, "Veo Estado Calificaciones") ? (
                                <button
                                  onClick={() => {
                                    setInstanciaSeleccionada(instancia);
                                    setModalEstadoCalificaciones(true);
                                  }}
                                  style={{ ...styles.btnAccion, background: '#1e40af' }}
                                >
                                  📊 Estado Calificaciones
                                </button>
                              ) : ""}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              ))}
          </div>
        ))}
      </div>
    </>
  );
};

const styles = {
  btnCrear: {
    background: '#4caf50',
    color: 'white',
    padding: '10px 15px',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  btnTodas: {
    background: '#2196f3',
    color: 'white',
    padding: '8px 12px',
    marginRight: '5px',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  btnActivas: {
    background: '#009688',
    color: 'white',
    padding: '8px 12px',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  tituloEscuela: {
    background: '#eee',
    padding: '10px',
    margin: 0,
    cursor: 'pointer',
  },
  tituloCurso: {
    cursor: 'pointer',
    background: '#f5f5f5',
    padding: '8px',
    margin: 0,
  },
  table: {
    borderCollapse: 'collapse',
    width: '100%',
    background: 'white',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginTop: '5px',
  },
  th: {
    width: '150px',
    padding: '8px',
    border: '1px solid #ddd',
  },
  td: {
    border: '1px solid #ddd',
    padding: '6px',
  },
  btnAccion: {
    color: 'white',
    padding: '6px 10px',
    marginRight: '5px',
    marginBottom: '5px',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  modalPantallaCompleta: {
    position: "fixed",
    inset: 0,
    width: "100vw",
    height: "100vh",
    zIndex: 999999,
    background: "#f8fafc",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    margin: 0,
    padding: 0,
    transform: "none",
    left: 0,
    top: 0
  },
  modalHeaderFull: {
    background: "#0f172a",
    color: "white",
    padding: "15px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  btnCerrarModalFull: {
    background: "#dc2626",
    border: "none",
    color: "white",
    padding: "8px 14px",
    borderRadius: "8px",
    cursor: "pointer"
  },
};

export default UserManagement;